export default __webpack_public_path__ + "fadf0c6f78fc10de02fc70445e9f2565.svg";